import { useEffect, useState } from "react";

// Where the browser shares it (Chromium's Battery Status API), this is the visitor's own battery.
// Elsewhere, a fully charged Mac running on battery.
const FALLBACK = { supported: false, level: 1, charging: false, chargingTime: Infinity };

const useBattery = () => {
  const [battery, setBattery] = useState(FALLBACK);

  useEffect(() => {
    if (typeof navigator === "undefined" || !navigator.getBattery) return undefined;
    const events = ["levelchange", "chargingchange", "chargingtimechange"];
    let manager = null;
    let cancelled = false;
    const read = () => {
      if (cancelled || !manager) return;
      setBattery({
        supported: true,
        level: manager.level,
        charging: manager.charging,
        chargingTime: manager.chargingTime,
      });
    };
    navigator
      .getBattery()
      .then((m) => {
        manager = m;
        read();
        events.forEach((e) => m.addEventListener(e, read));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (manager) events.forEach((e) => manager.removeEventListener(e, read));
    };
  }, []);

  return battery;
};

export default useBattery;
